const stringXPosition = (
  startingX: number,
  stringDistance: number,
  string: number,
) => {
  return startingX + string * stringDistance
}

export { stringXPosition }
